import { gql } from '@apollo/client';

export default gql`
  query checkinTimes($reference: String!) {
    checkinTimes(reference: $reference) {
      passengerId
      rules {
        tcn
        arrivalTime
      }
    }
  }
`;
